export function parseSearchParams(search: string) {
  const result: { [key: string]: string } = {};
  const pairs = search.substring(1).split("&");
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split("=");
    result[pair[0]] = decodeURIComponent(pair[1]);
  }
  return result;
}
